/* @flow */
export const PushEvents = {
  CLASS_MEMBERSHIP: 'classmembership',
  CONNECTION_STATE_CHANGED: 'state_change',
  USER: 'user',
  RETRY_CONNECTION: 'retry_connection',
  RESET_STORE: 'reset_store',
  MARKER_UPDATE: 'marker_updates',
  TEST_MESSAGE: 'test_message',

  // delivery updates
  CHANGESET_UPDATE_DELIVERY_UPDATES: 'changeset-update-delivery_updates',

  // chat message
  CHANGESET_CREATE_CHAT_MESSAGE: 'changeset-create-chat_message',

  // group
  CHANGESET_UPDATE_GROUP: 'changeset-update-group',
  CHANGESET_CREATE_GROUP: 'changeset-create-group',
  CHANGESET_DESTROY_GROUP: 'changeset-destroy-group',

  // unread
  CHANGESET_UPDATE_UNREADS: 'changeset-update-unreads',

  // chat
  CHANGESET_UPDATE_CHAT: 'changeset-update-chat',
  CHANGESET_UPDATE_CHATS: 'changeset-update-chats',

  // class memberships
  CHANGESET_CREATE_CLASSMEMBERSHIP: 'changeset-create-classmembership',
  CHANGESET_DESTROY_CLASSMEMBERSHIP: 'changeset-destroy-classmembership',

  // devices
  CHANGESET_DESTROY_DEVICE: 'changeset-destroy-device',
  CHANGESET_UPDATE_DEVICE: 'changeset-update-device',
  CHANGESET_CREATE_DEVICE: 'changeset-create-device',

  // desktop notification
  CHANGESET_CREATE_DESKTOP_NOTIFICATION: 'changeset-create-desktop_notification',

  // user
  CHANGESET_UPDATE_USER: 'changeset-update-user',

  // reactions
  CONTENT_UPDATE_CHAT_MESSAGE_REACTION: 'content-update-chat_message_reaction',
  CONTENT_UPDATE_CHAT_BROADCAST_REACTION: 'content-update-chat_broadcast_reaction',
};



// WEBPACK FOOTER //
// ./src/pusher/PusherConstants.js